var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from './data';
var Member = /** @class */ (function (_super) {
    __extends(Member, _super);
    function Member() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Member";
        _this.admin = false;
        _this.readOnly = false;
        _this.sessionTimeout = 0;
        _this.marketing = false;
        return _this;
    }
    Member.toMemberData = function (member) {
        var json = {};
        json["id"] = member.id;
        json["sessionId"] = member.sessionId;
        json["username"] = member.username;
        json["storeId"] = member.storeId;
        json["type"] = member.type;
        json["regions"] = member.regions;
        json["language"] = member.language;
        json["name"] = member.name;
        json["gender"] = member.gender;
        json["firstName"] = member.firstName;
        json["lastName"] = member.lastName;
        json["groupId"] = member.groupId;
        json["brandId"] = member.brandId;
        json["storeId"] = member.storeId;
        json["phone"] = member.phone;
        json["backendId"] = member.backendId;
        json["birthdate"] = member.birthdate;
        json["marketing"] = member.marketing;
        json["cardNo"] = member.cardNo;
        json["membership"] = member.membership;
        json["tier"] = member.tier;
        json["allowereceipt"] = member.allowereceipt;
        return json;
    };
    return Member;
}(Data));
export { Member };
//# sourceMappingURL=member.js.map